import React from "react"
import {listOutline, listSharp} from "ionicons/icons"

import TypeIcon from "./TypeIcon"

interface props {
    link?: string
    size?: "small" | "default" | "large"
    slot?: string
    text?: string
}

const IconTimeLimitData: React.FC<props> = ({ link, size, slot, text }) => {

    return <TypeIcon
        backgroundColor={'DarkGoldenRod'}
        link={link}
        ios={listOutline}
        md={listSharp}
        size={size}
        slot={slot}
        text={text}
    />

}

export default IconTimeLimitData